define.alias("shared/components/shared/social/refresh-profile/base-button", "media/components/shared/social/refresh-profile/base-button");